import {STATES} from '../content/states';
import {S} from './state';
import {clamp} from './util';



export function brCount(){let y=0;for(const id in STATES)if(S.gov[id]==='YOU'||S.partners.includes(S.gov[id]))y+=STATES[id].v;return y}

export function moodT(v?:any){return clamp((v-35)/30,0,1)}

export function seatPoints(){
  const R=10,r0=.42,radii=[...Array(R)].map((_,i)=>r0+(1-r0)*i/(R-1)),sr=radii.reduce((a,b)=>a+b,0);
  const cnt=radii.map(r=>Math.round(630*r/sr));cnt[R-1]+=630-cnt.reduce((a,b)=>a+b,0);
  const pts:any[]=[];radii.forEach((r,i)=>{const n=cnt[i];for(let j=0;j<n;j++){const th=Math.PI-j*Math.PI/(n-1);pts.push({x:r*Math.cos(th),y:r*Math.sin(th),th})}});
  pts.sort((a,b)=>b.th-a.th||a.x-b.x);
  const cols:string[]=[];S.res.inP.forEach((id:string)=>{for(let k=0;k<S.res.seats[id];k++)cols.push(id)});
  pts.forEach((p,i)=>p.pid=cols[i]);return pts;
}
